import progressBar from '../../../shared/DOM/progressBar.js';
import { getEnrollmentSteps } from '../api/getEnrollmentSteps.js';
import { ENROLLMENT_STEPS } from '../steps/enrollment-steps.constant.js';

/**
 * ViewEnrollment.getData: podemos usar this para acceder a sus propiedades
 *
 * @returns enrollment steps
 */
export async function getSteps() {
  try {
    progressBar.loading();

    const steps = await getEnrollmentSteps(this.token);
    if (!steps?.length) {
      throw new Error('enrollment.steps_error');
    }

    progressBar.resolved();
    return getStepsWithTemplate(steps);
  } catch (error) {
    progressBar.rejected();
    throw error;
  }
}

async function getStepsWithTemplate(steps) {
  steps.forEach((item) => {
    const step = getStepJson(item.step);
    Object.assign(item, step);
  });

  return steps;
}

/**
 * IMPORTANTE: Si no existe el paso propagamos para revisar el XML (antes se saltaba)
 * Module not found in bundle: ../steps/8.constant.js
 *
 * OPCIONES:
 *
 * step.events:
 * {
 *   visible: acción al entrar en un paso
 *   step: acción antes de ir al siguiente paso / finish
 * }
 * step.template: template para el wizard
 *
 * @param {*} step
 * @returns
 */
function getStepJson(step) {
  return require(`../steps/${ENROLLMENT_STEPS[step] || step}.constant.js`).default;
}
